import { RefreshControl, View, VStack } from "@gluestack-ui/themed";
import { ProposalsHeader } from "./components/ProposalsHeader";

import { ProposalGroup } from "@repo/core/components/layout/ProposalGroup";

import { ProposalsSearchController } from "./controller";
import { ScrollView } from "@repo/core/components/layout/ScrollView";
import { Fab } from "@repo/core/components/core/Fab";

import { ProposalOptionsSheet } from "./components/ProposalOptionsSheet";

import { ProposalsSearchLoading } from "./loading";
import { StatusBar } from "@repo/core/components/layout/StatusBar";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { shouldShowProposalsSkeleton } from "./utils";
function ProposalsSearch() {
  const {
    proposals,
    marginBottomFab,
    marginRightFab,
    actionSheetRef,
    handleOpenOptions,
    shouldShowOptions,
    startPreProposal,
    isStartingPreProposal,
    onRefresh,
    refreshing,
    updatedText,
    searchText,
    setSearchText,
    isFetching,
    isLoading,
    selectedCategory,
    setSelectedCategory,
    hideStatusFilters
  } = ProposalsSearchController();
  const showSkeleton = shouldShowProposalsSkeleton({
    isLoading,
    isFetching,
    refreshing
  });

  return (
    <>
      <StatusBar
        showCustomStatusBar
        statusBarVariant={StatusBarVariantEnum.GREEN}
      />
      <ScrollView
        flex={1}
        bgColor="$backgroundLight100"
        refreshControl={
          <RefreshControl
            bg="$primary700"
            refreshing={refreshing}
            onRefresh={onRefresh}
          />
        }
      >
        <View w="$full">
          <ProposalsHeader
            onRefresh={onRefresh}
            updatedText={updatedText}
            searchText={searchText}
            setSearchText={setSearchText}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            hideStatusFilters={hideStatusFilters}
            isLoading={isFetching}
          />
          <VStack p="$6" bgColor="$backgroundLight100">
            {showSkeleton ? (
              <ProposalsSearchLoading />
            ) : (
              <ProposalGroup
                items={proposals}
                onPressOption={handleOpenOptions}
                shouldShowOptions={shouldShowOptions}
              />
            )}
          </VStack>
        </View>
      </ScrollView>
      <Fab
        size="lg"
        bg="$primary700"
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mb={marginBottomFab as any}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mr={marginRightFab as any}
        onPress={startPreProposal}
        isLoading={isStartingPreProposal}
        isDisabled={isStartingPreProposal}
        label="Nova Proposta"
      />
      <ProposalOptionsSheet ref={actionSheetRef} />
    </>
  );
}

export default ProposalsSearch;
